import styled from 'styled-components';

export default styled.div`
  height: 100%;
  overflow: hidden;
  form {
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 60px;
    .from-content {
      height: 100%;
      flex-shrink: 1;
      overflow: auto;
      display: flex;
      gap: 48px;
      .left-content {
        width: 400px;
        display: flex;
        flex-direction: column;
        gap: 24px;
        .hit-rate-wrap {
          display: flex;
          gap: 4px;
          align-items: center;
          label {
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            color: #333;
            span {
              display: inline-block;
              width: 7px;
              font-weight: 400;
              font-size: 12px;
              line-height: 100%;
              color: #d10000;
            }
          }
          .hit-rate-input-wrap {
            width: 55px;
          }
        }
        .mention {
          font-weight: 400;
          font-size: 12px;
          line-height: 17px;
          color: #616161;
          position: relative;
          top: -6px;
        }
      }
      .right-content {
        display: flex;
        flex-direction: column;
        gap: 6px;
      }

      .MuiCheckbox-root {
        padding: 0;
      }
    }
  }
`;
